import { Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import { ReactComponent as CloseIcon } from "../../assets/icons/x.svg";
import Button from "../../components/Button";
import FormField from "../../components/FormField";
import { PopupModal } from "../../components/Modal";
import { ShowToast } from "../../components/toast";
import { api } from "../../helpers/api";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    // .matches(/^[^\s+@]+@[^\s@]+\.[^\s@]+$/, "Invalid email address")
    .email("Invalid email")
    .required("Email is required"),
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password is too short")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,}$/g,
      "Password must contain at least one uppercase and at least one lowercase letter and at least one special character",
    ),
});

const LoginFormContent = () => {
  const { isValid, isSubmitting, submitForm } = useFormikContext();

  return (
    <div className="flex flex-col items-center h-full justify-center">
      <div className="flex flex-col w-full">
        <Form className="flex w-full flex-col gap-6 mb-[1.5rem]">
          <h1 className="text-black text-[28px] font-bold tracking-[-1.12px] leading-[100%]">
            Add admin user
          </h1>
          <div className="grid gap-4">
            <div className="flex gap-4 [&>div]:flex-1">
              <FormField
                label="First name"
                name="firstName"
                type="text"
                placeholder="Enter your first name"
                className="w-full"
              />
              <FormField
                label="Last name"
                name="lastName"
                type="text"
                placeholder="Enter your last name"
                className="w-full"
              />
            </div>
            <FormField
              label="Email"
              name="email"
              type="email"
              placeholder="Enter your email"
            />
            <FormField
              label="Password"
              name="password"
              type="password"
              placeholder="Enter your password"
            />
          </div>
          <div className="grid gap-7 mt-2">
            <Button
              className="w-full !bg-black"
              type="submit"
              disabled={!isValid}
              loading={isSubmitting}
              onClick={() => submitForm()}
            >
              Add
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

const LoginForm = ({ onClose }: { onClose: () => void }) => {
  return (
    <div className="flex-1">
      <Formik
        initialValues={{ email: "", password: "" }}
        isInitialValid={false}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => {
          console.log(values);
          api
            .addUser({
              ...values,
              userType: "U",
            })
            .then(async (res) => {
              actions.setSubmitting(false);
              ShowToast({
                message: "User added successfully",
                type: "success",
              });
              onClose();
            })
            .catch((err) => {
              actions.setSubmitting(false);

              ShowToast({
                message:
                  err.response.data.message || "Invalid email or password",
                type: "error",
              });
            });
        }}
      >
        <LoginFormContent />
      </Formik>
    </div>
  );
};

export function AddUserModal({ onClose }: { onClose: () => void }) {
  return (
    <PopupModal onClose={onClose} contentClassName="w-[500px] mx-auto relative">
      <button
        onClick={onClose}
        className="absolute top-0 -right-0 [&_path]:stroke-content-primary p-2 bg-surface-secondary rounded-full"
      >
        <CloseIcon onClick={onClose} className="w-6 h-6" />
      </button>
      <LoginForm onClose={onClose} />
    </PopupModal>
  );
}
